import {AfterContentInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AuthService} from 'src/shared/service/auth.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {finalize} from 'rxjs/operators';
import {DictionaryPipe} from '../../../shared/pipes/dictionary.pipe';
import {AbstractDataProvider} from '../../AbstractDataProvider';
import {SecurityQuestionAnswer} from '../../security/QueryStringParam';
import {GetResetPasswordTokenBySecurityAnswersModel, SecurityQuestionsDto} from '../../../shared/model/interfaces';
import {getErrorMessageText} from '../../helper';

@Component({
  selector: 'app-security-question',
  templateUrl: './security-answers.component.html',
  styleUrls: ['./security-answers.component.scss'],
  providers: [DictionaryPipe]
})
export class SecurityAnswersComponent implements OnInit, AfterContentInit {

  userId: string;
  alertMessage: string;
  display = false;

  clientCode: string;
  clientName: string;
  clientPhoneNumber: string;
  logoImageUrl: string;
  emailAddress: string;
  displaySuccessMessage: boolean;
  displayQuestions: boolean;

  securityAnswers: SecurityQuestionAnswer = new SecurityQuestionAnswer();

  constructor(private abstractDataProvider: AbstractDataProvider,
              private authService: AuthService,
              private route: ActivatedRoute,
              private ngxService: NgxUiLoaderService,
              private dictionaryPipe: DictionaryPipe) {
    this.route.queryParams.subscribe(queryParam => {
      this.userId = queryParam.userId;
      this.securityAnswers.SecQuestionCode1 = queryParam.question_1;
      this.securityAnswers.SecQuestionCode2 = queryParam.question_2;
      this.securityAnswers.SecQuestionCode3 = queryParam.question_3;
      if (!this.userId || !this.securityAnswers.SecQuestionCode1 || !this.securityAnswers.SecQuestionCode2 || !this.securityAnswers.SecQuestionCode3) {
        this.navigateHome();
      } else {
        this.getListOfSecurityQuestions();
      }
    });
  }


  ngOnInit() {
  }

  ngAfterContentInit() {
    this.clientCode = this.authService.clientCode;
    this.clientName = this.authService.wpCompanyName;
    this.clientPhoneNumber = this.authService.wpContactPhone;
    this.logoImageUrl = this.authService.clientLogoUrl;
  }


  navigateHome() {
    this.authService.navigateToLogin();
  }

  requestEmail(): void {
    if (!this.userId) {
      return;
    }
    this.ngxService.start();
    this.abstractDataProvider.postData({UserId: this.userId}, 'api/Accounts/SendResetPasswordEmail')
      .pipe(finalize(() => this.ngxService.stop()))
      .subscribe((data) => {
        this.displaySuccessMessage = true;
      }, error => {
        this.display = true;
        this.alertMessage =  getErrorMessageText(error);
      });
  }

  hidePopupAndNavigateHome() {
    this.displaySuccessMessage = false;
    this.authService.navigateToLogin();
  }

  getListOfSecurityQuestions() {
    this.ngxService.start();
    this.abstractDataProvider.getData('api/Configuration/GetSecurityQuestionList').pipe(finalize(() => this.ngxService.stop())).subscribe(
      (data: SecurityQuestionsDto) => {

        const index1 = data.SecurityQuestions.findIndex(q => q.SecQuestionCode === this.securityAnswers.SecQuestionCode1);
        if (index1 > -1) {
          this.securityAnswers.SecQuestionText1 = data.SecurityQuestions[index1].SecQuestionText;
        }

        const index2 = data.SecurityQuestions.findIndex(q => q.SecQuestionCode === this.securityAnswers.SecQuestionCode2);
        if (index1 > -1) {
          this.securityAnswers.SecQuestionText2 = data.SecurityQuestions[index2].SecQuestionText;
        }

        const index3 = data.SecurityQuestions.findIndex(q => q.SecQuestionCode === this.securityAnswers.SecQuestionCode3);
        if (index1 > -1) {
          this.securityAnswers.SecQuestionText3 = data.SecurityQuestions[index3].SecQuestionText;
        }
        this.displayQuestions = true;
      },
      (error) => {
        this.display = true;
        this.alertMessage =  getErrorMessageText(error);
      }
    );
  }

  submitTheAnswer() {
    if (!this.isValid()) {
      return;
    }

    this.ngxService.start();
    const dto = {
      UserId: this.userId,
      Answer1: this.securityAnswers.SecAnswerText1,
      Answer2: this.securityAnswers.SecAnswerText2,
      Answer3: this.securityAnswers.SecAnswerText3
    };
    this.abstractDataProvider.postData(dto, 'api/Accounts/GetResetPasswordTokenBySecurityAnswers').pipe(finalize(() => this.ngxService.stop()))
      .subscribe((data: GetResetPasswordTokenBySecurityAnswersModel) => {
        if (data && data.Data && data.Data.Token) {
          const params = {
            userId: this.userId,
            token: data.Data.Token
          };
          this.authService.navigateToUrl('reset-password', params);
        }
      }, error => {
        this.display = true;
        this.alertMessage =  getErrorMessageText(error);
      });
    // TODO: request

  }

  private isValid(): boolean {
    const validatedObj = this.authService.validateSecurityQuestionAnswer(this.securityAnswers);
    if (validatedObj.isValid === false) {
      this.display = true;
      this.alertMessage = validatedObj.alertmessage;
    }
    return validatedObj.isValid;
  }

}
